import styles from "./style.module.scss";
import fullBattery from "../../images/icons/battery/full.svg";
import mediumBattery from "../../images/icons/battery/medium.svg";
import lowBattery from "../../images/icons/battery/low.svg";

const BatteryIcon = ({ percent }) => {
  let batteryIcon;

  if (percent > 69) {
    batteryIcon = fullBattery;
  } else if (percent > 30) {
    batteryIcon = mediumBattery;
  } else {
    batteryIcon = lowBattery;
  }

  return (
    <div className={styles.batteryContainer}>
      <img src={batteryIcon} alt="Battery" />
    </div>
  );
};

export default BatteryIcon;
